/**
 * @file: 满意度调查抽屉用的 表单 + 回显
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/8/7      1.0     First version ， disabled为true 即回显用
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent,Fragment} from "react";
import { Radio,Space,Input,Checkbox,Select,Form} from 'antd';
import PropTypes from "prop-types";
import Lang from "@/components/Lang/Lang";
import "./surveyTaskFrom.less";
const { TextArea } = Input;
const CheckboxGroup = Checkbox.Group;
const FormItem = Form.Item;
export default class SurveyTaskFromShow extends PureComponent {
    static propTypes = {
        item: PropTypes.object,// name telCode mobile abbreviate buyerCode
        disabled:PropTypes.bool,
    };
    static defaultProps = {
        item: {}, // 显示
        questionList:[],
        surveyList:[],
        disabled: false,
        buyerSurveyTaskId:null, //当前问卷
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }
    formRef = React.createRef();
    loading(flag){
        this.setState({
            loading:flag
        })
    }
     onChange = (key,value) => {
        const { resMap = {}} = this.state;
        let nResMap = {...resMap};
            nResMap[key] = value;
        this.setState({
            resMap: nResMap
        })
    };
    /**
     * flagShowInx 是否显示序号，true 为一级问题，加上行距
     * */
    renderOne(inx,title={},qObj={},resMap={},flagShowInx=false){
        const {disabled,buyerSurveyTaskId} = this.props;
        let initialValue = null;
        if(disabled){
            initialValue = qObj.optionType==2?(qObj.answer?qObj.answer.split(","):[]):qObj.answer;
        }
        return (<div className={flagShowInx?"bgWhiteBox mb_12":"ml_16 mt_12"} key={buyerSurveyTaskId+"_ql_"+inx}>
            <div className={"font_16 fw_700 lineH_24 mb_12"}>{flagShowInx?<span className={"mr_6"}>{inx}.</span>:null}{title}</div>
            {/* optionType 1:单选 有选项 * 2:多选 有选项 * 3:文本 无选项*/}
            <FormItem  key={qObj.categoryCode}
                name={qObj.categoryCode}
                initialValue={initialValue}
                rules={[
                    {
                        required: true,
                        message: Lang(qObj.optionType==3?{id:"QingShuRu",default:"请输入"}:{id:"QingXuanZe2",default:"请选择"})
                    },
                ]}
            >
            {this.renderType(inx,qObj.optionType,qObj,resMap)}
            </FormItem>
        </div>)
    }
    renderType(inx,type,qObj,resMap={}){
        const {disabled} = this.props;
        switch (type) {
            case 1:
                const preAnswerList = qObj.preAnswerList || [];
                const value = disabled?qObj.answer:resMap[qObj.categoryCode];
                return (<Radio.Group style={{width:"100%"}}
                                     key={"_Type_"+inx+"_"+qObj.categoryCode}
                                     onChange={(e)=>this.onChange(qObj.categoryCode,e.target.value)} disabled={disabled}>
                    <Space direction="vertical" style={{width:"100%"}}>
                        {preAnswerList.map((item,subInx)=>{
                            const subList = item.answerItemList || item.questionItemList||[];
                            return (<div key={inx+"_"+subInx+"_"+qObj.categoryCode}>
                                <Radio value={item.code} style={{width:"100%"}}>{item.name} </Radio>
                                {value === item.code && subList.length>0 ?<div>
                                    {subList.map((subQ,sInx)=>this.renderOne(inx+"_"+subInx+"_"+sInx,subQ.categoryName,subQ,resMap) )}
                                </div>: null}
                            </div>)})
                        }
                    </Space>
                </Radio.Group>);
            case 2:
                const preAnswerList2 = qObj.preAnswerList || [];
                const value2 = !disabled&&resMap[qObj.categoryCode];
                return (<CheckboxGroup style={{width:"100%"}}
                                       key={"_Type_"+qObj.categoryCode}
                                       onChange={(checkedValues)=>this.onChange(qObj.categoryCode,checkedValues)} disabled={disabled}>
                    <Space direction="vertical" style={{width:"100%"}}>
                        {preAnswerList2.map((item,subInx)=>{
                            const subList = item.answerItemList || item.questionItemList||[];
                            return (<div key={inx+"_Type_"+subInx+qObj.categoryCode}>
                                <Checkbox style={{width:"100%"}} value={item.code} key={inx+"_"+item.code}>{item.name}</Checkbox>
                                {$.inArray(item.code, value2) !== -1 && subList.length>0 ?<div>
                                    {subList.map((subQ,sInx)=>this.renderOne(inx+"_"+sInx,subQ.categoryName,subQ,resMap) )}
                                </div>: null}
                            </div>)
                        }) }
                    </Space>
                </CheckboxGroup>);
            case 3:
                const value3 = disabled?qObj["answer"]:resMap[qObj.categoryCode];
                return (<TextArea rows={4} disabled={disabled}
                                  key={"_Type_"+qObj.categoryCode}
                                 style={{width:"100%"}}
                                  value={value3}
                                 onChange={(e)=>this.onChange(qObj.categoryCode,e.target.value)}
                                 placeholder={Lang({id:"QingShuRu",default:"请输入"})} maxLength={512} />)
            default:
                return null
        }
    }
    getValue = async() => {
        const {resMap={},} = this.state;
        try {
            const values = await this.formRef.current.validateFields();
            let vaList = []
            for(let key in resMap){
                const sAns = resMap[key];
                vaList.push({
                    categoryCode:key,
                    answer: sAns.constructor===Array?sAns.join(","):sAns
                })
            }
            return vaList;
        } catch (errorInfo) {
            console.log("errorInfo",errorInfo)
            return false
        }

    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    handleChangeSurvey(value){
        if(this.props.handleChangeSurvey){
            this.props.handleChangeSurvey(value,()=>{
                this.setState({
                    reload:true
                },()=>{
                    this.setState({
                        reload:false
                    })
                })
            })
        }
        this.setState({
            resMap:{},
        })
    }
    componentWillMount() {
    }
    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };
    render() {
        const { item={}, questionList=[], surveyList,buyerSurveyTaskId} = this.props;
        const {resMap={},reload=false} = this.state;
        const sCountryUrl =item.abbreviate?require('../../assets/img/country/'+item.abbreviate + '.png'):"";
        return (<Fragment>
            <div className={"bgWhiteBox mb_12"}>
                <div className={"flex-item-between flex-item-ver-center lineH_27"}>
                    <div>
                        {item.abbreviate?<img className="mr_8" src={sCountryUrl.default} width={24} />:null}
                        <span className={"fw_700 font_18"}>{item.buyerCode||"-"}</span>
                    </div>
                    <div className={"fw_700 flex-item-ver-center"}>
                        <i className={"ri-phone-fill mr_4 black45 font_20 fw_400"} />
                        {item.telCode?<span className={"mr_4"}>+{item.telCode}</span>:""}{item.mobile||"--"}
                    </div>
                </div>
                <div className={"black45 lineH_21"}>{item.name}</div>
            </div>
            {surveyList&&surveyList.length>0?<div className={"mb_12"}>
                <div className={"mb_6 font_14 black89"}>  {Lang({id:"DiaoChaWenJuan",default:"调查问卷"})}</div>
                <Select value={buyerSurveyTaskId}
                    style={{  width: 216, }}
                    onChange={(v)=>this.handleChangeSurvey(v)}
                    options={surveyList}
                    fieldNames={{label:"surveyName",value:"buyerSurveyTaskId"}}
                />
            </div>:null}
            {!reload&&<Form
                name={buyerSurveyTaskId+"_basicSurveyTaskFrom"}
                ref={this.formRef}
                autoComplete="off"
            >
            {questionList.map((qObj,inx)=>this.renderOne(inx+1,qObj.categoryName,qObj,resMap,true))}
            </Form>}
        </Fragment>);
    }
}